export default __webpack_public_path__ + "static/media/scattered-clouds.fbfdd929.svg";